<template>
    <Head>
        <title>Журнал действий {{ user.name }}</title>
    </Head>

    <AuthenticatedLayout>
        <template #header>
            <NavigationSettings />
        </template>

        <div class="bg-white">
            <div class="py-2 px-6">
                <Link :href="route('settings.users.edit', user.id)" class="underline text-sm text-gray-600 hover:text-gray-900">Назад к пользователю</Link>
            </div>
            <div class="grid grid-cols-8 py-2 px-6 gap-2 font-bold">
                <span class="col-span-3">Описание</span>
                <span class="col-span-2 text-center">Статус</span>
                <span class="col-span-2 text-right">Дата</span>
            </div>
            <div class="grid grid-cols-8 py-2 px-6 gap-2 border-t items-start" v-for="action in actions.data">
                <span v-if="action.title" class="col-span-3" v-html="marked(action.title)"  />
                <span v-else class="col-span-3"/>
                <span class="col-span-2 text-center">{{ statusTitle(action.status) }}</span>
                <span class="col-span-2 text-right">{{ moment(action.created_at).utc().format('L LTS') }}</span>
                <div class="flex flex-row justify-end gap-2">
                    <div class="cursor-pointer" @click="action.showInfo = !action.showInfo">
                        <span v-if="!action.showInfo">+</span>
                        <span v-else>-</span>
                    </div>
                </div>
                <div class="col-span-4" v-show="action.showInfo || false">
                    <span>Параметры</span>
                    <pre class="text-xs text-white bg-gray-700 p-2 rounded">{{ action.params }}</pre>
                </div>
                <div class="col-span-4" v-show="action.showInfo || false">
                    <span>Результат</span>
                    <pre class="text-xs text-white bg-gray-700 p-2 rounded">{{ action.result }}</pre>
                </div>
            </div>
            <v-pagination class="p-6" :links="actions.links"/>
        </div>
    </AuthenticatedLayout>
</template>

<script>
import AuthenticatedLayout from '@/Layouts/Authenticated.vue';
import NavigationSettings from '@/Components/Navigation/Settings';
import moment from 'moment';
import {marked} from "marked";
import {Head, Link, useForm} from '@inertiajs/inertia-vue3';
import FormChangePassword from '@/Components/Forms/ChangePassword';
import TwoFactorAuthentication from '@/Components/Forms/2FA';
import NavLink from '@/Components/NavLink.vue';
import VButton from '@/Components/Button';
import VInput from '@/Components/Input';
import VPagination from '@/Components/Pagination';

export default {
    components: {
        Head, Link,
        NavigationSettings,
        AuthenticatedLayout,
        FormChangePassword,
        TwoFactorAuthentication,
        NavLink,
        VButton,
        VInput,
        VPagination,
    },
    data() {
        return {

        }
    },
    props: {
        user: Object,
        actions: Object,
    },
    methods: {
        moment,
        marked,
        statusTitle(s) {
            const t = {
                add: 'Добавлено, не отправлено',
                wait: 'Ожидает подтверждения',
                confirm: 'Подтверждено',
                cancel: 'Отказано',
                complete: 'Выполнено',
                fail: 'Не удалось выполнить',
                exception: 'Внутренняя ошибка',
            }
            return t[s];
        }
    }
}
</script>
